export const errMessageForm = {
    "minLength": "*La contaseña es muy corta",
    "required": "*Este campo es obligatorio",
    "pattern": "*El campo no tiene un formato válido",
    "userIsNotBirthday": "Esta actividad es solo para cumpleañeras",
    "errService": "*Opps! algo no estuvo bien",
    "maxLength": "*La clave ingresada es inválida"
}